module.exports = __webpack_public_path__ + "static/media/server.0f0f7d55.png";